import { BaseService } from './baseService';
import axiosInstance from '../axiosInstance';

class SmsMessagesService extends BaseService<
	SmsMessage,
	'smsMessageID',
	'smsMessages'
> {
	constructor() {
		super('smsMessageID', 'smsMessage', 'smsMessages');
	}

	async createFromTemplate(smsMessageTemplateID: number) {
		const response = await axiosInstance.post(
			`/app/smsMessages/createFromTemplate`,
			{
				smsMessageTemplateID: smsMessageTemplateID,
			},
		);

		return response.data;
	}

	async createMessageFromMessage(smsMessageID: number, name: string) {
		const response = await axiosInstance.post(
			`/app/smsMessages/createFromSms`,
			{
				smsMessageID: smsMessageID,
				name: name,
			},
		);

		return response.data;
	}

	async getAllSenderNames() {
		const response = await axiosInstance.get(
			'/app/smsMessages/senderNames',
		);

		return response.data.data.senderNames;
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new SmsMessagesService();
